module.exports = __webpack_public_path__ + "static/tesh-fshot-kesto-4724fb7d2b860b8e5512e66c5268a811.jpg";